<template>
  <div class="container-fluid p-0">
    <AppHeader />
    
       <main class="container-fluid p-0">
      <router-view :key="$route.fullPath" />
    </main>
     <br/><br/><br/><br/>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '../components/AppNavigationHeader.vue'
//import AppHeader from '../components/AppHeader.vue'
import AppFooter from '../components/AppFooter.vue'

export default {
  components: { AppHeader, AppFooter }
};
</script>
